export enum SHORT_LINK_INSTANCE {
  unlockLink = 'UNLOCKLINK',
  reservation = 'RESERVATION',
  housing = 'HOUSING',
}

export enum SHORT_LINK_TYPE {
  main = 'RESERVATION_SIGN_UP_FORM',
  payment = 'RESERVATION_PAYMENT',
  upselling = 'RESERVATION_UPSELLING',
  lock = 'RESERVATION_LOCK',
  ivHousing = 'HOUSING_IDENTITY_VERIFICATION',
  housingCheckinOnline = 'HOUSING_CHECKIN_ONLINE',
  housingGuidebook = 'HOUSING_GUIDEBOOK',
  housingDirectReservation = 'HOUSING_DIRECT_RESERVATION',
}

export enum AUTH_INIT_MODELS {
  housing = 'Housing',
  user = 'User',
  reservation = 'Reservation',
}

export const RESERVATION_ID_KEY = 'chekin-reservation-id';
export const HOUSING_ID_KEY = 'chekin-housing-id';
export const HOST_ID_KEY = 'chekin-host-user-id';
export const MAIN_TOKEN_ID_KEY = 'main-token';
